module.exports = __webpack_public_path__ + "static/media/logout.9f64b6ad.svg";